
<m-expansion-panel [id]="'dividasPendentes-protestos'" [title]="'Protestos'" [active]="larguraEhSuperiorMin">
  <div *ngIf="protestos.resultados.length > 0"
    class="table-responsive" id="div-table-dividasPendentes-protestos">
    <table id="id-table-dividasPendentes-protestos" class="table table-sm table-striped table-borderless" aria-label="Tabela de dívidas pendentes protestos" style="font-size: smaller;">
        <thead>
            <tr>
                <th scope="col">Nº Cartório</th>
                <th scope="col">Cartório</th>
                <th scope="col">Data do vencimento</th>
                <th scope="col">Data da inclusão</th>
                <th scope="col">Valor</th>
                <th scope="col">Cidade</th>
                <th scope="col">UF</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let protesto of protestos.resultados; index as i">
                <td>{{ protesto.numeroCartorio | naoinformado }}</td>
                <td>{{ protesto.cartorio | naoinformado }}</td>
                <td>{{ protesto.dataVencimento | naoinformado }}</td>
                <td>{{ protesto.dataInclusao | naoinformado }}</td>
                <td>{{ protesto.valor | moedaReal }}</td>
                <td>{{ protesto.cidade | naoinformado }}</td>
                <td>{{ protesto.uf | naoinformado }}</td>
            </tr>
        </tbody>
    </table>
</div>
<div id="id-div-dividasPendentes-protestos-falha"
    *ngIf="listaServicoFalha.includes('bloco-protestos') || protestos.resultados.length == 0">
    {{protestos.falhaServico.message}}
</div>

</m-expansion-panel>
